import { Component, OnInit, Input } from '@angular/core';
import { StrictValuePipe } from 'src/app/shared/pipes/strict-value.pipe';
import { ListItemType } from './models/list-item-type.enum';
import { IListItemModel } from './models/list-item.model';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
})
export class ListItemComponent implements OnInit {
  @Input() item?: IListItemModel;

  public itemType: typeof ListItemType = ListItemType;

  constructor(private strictValuePipe: StrictValuePipe) {}

  ngOnInit(): void {}

  setStrictValue(item: IListItemModel): string {
    return this.strictValuePipe.transform(item.value, item.strictKey!);
  }
}
